/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export interface BooleanObject
{
    value:boolean;
}